/**
 * Mixin para funcionalidades do template NiceShop
 * Pode ser usado em qualquer componente Vue
 */

import { 
  initAOS, 
  initGLightbox, 
  initPureCounter, 
  initSwiper, 
  initDrift,
  initMobileNav,
  initScrollTop,
  initMobileDropdowns,
  initFAQ,
  initScrollClass,
  initPreloader,
  initCountdown
} from '../utils/templateScripts'

export default {
  methods: {
    // Métodos para inicializar funcionalidades específicas
    initAOS() {
      this.$nextTick(() => {
        initAOS()
      })
    },
    
    initGLightbox() {
      this.$nextTick(() => {
        initGLightbox()
      })
    },
    
    initPureCounter() {
      this.$nextTick(() => {
        initPureCounter()
      })
    },
    
    initSwiper() {
      this.$nextTick(() => {
        initSwiper()
      })
    },
    
    initDrift() {
      this.$nextTick(() => {
        initDrift()
      })
    },
    
    initMobileNav() {
      this.$nextTick(() => {
        initMobileNav()
      })
    },
    
    initScrollTop() {
      this.$nextTick(() => {
        initScrollTop()
      })
    },
    
    initMobileDropdowns() {
      this.$nextTick(() => {
        initMobileDropdowns()
      })
    },
    
    initFAQ() {
      this.$nextTick(() => {
        initFAQ()
      })
    },
    
    initScrollClass() {
      this.$nextTick(() => {
        initScrollClass()
      })
    },
    
    initPreloader() {
      this.$nextTick(() => {
        initPreloader()
      })
    },
    
    initCountdown() {
      this.$nextTick(() => {
        initCountdown()
      })
    },
    
    // Método para inicializar todas as funcionalidades
    initAllTemplateFeatures() {
      this.$nextTick(() => {
        initAOS()
        initGLightbox()
        initPureCounter()
        initSwiper()
        initDrift()
        initMobileNav()
        initScrollTop()
        initMobileDropdowns()
        initFAQ()
        initScrollClass()
        initPreloader()
        initCountdown()
      })
    }
  },
  
  mounted() {
    // Inicializa automaticamente algumas funcionalidades básicas
    this.initScrollClass()
    this.initPreloader()
  }
}
